
const initialState = {
    study: [],
};

const studyReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_STUDY_NAME":
            return state = {
                ...state,
                study: [action.payload, ...state.study ],
            }
        case "UPDATE_STUDY_NAME":
            return state = { ...state, study: state?.study?.map((study) => study._id === action.payload._id ? action?.payload : study)}

        case "UPDATE_STUDY_STATUS":
            return state = {
                ...state,
                study: state?.study?.map((study) =>
                    study._id === action.payload._id ? action?.payload : study
                ),
            }
            case "GET_ALL_STUDY":
                return { ...state, study: action.payload };
        default:
            return state;
    }
}

export default studyReducer;